import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const shiftDailyScheduleApi = createApi({
  reducerPath: "shiftDailyScheduleApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/" }),
  tagTypes: ["ShiftDailySchedule"],
  endpoints: (builder) => ({
    getSchedulesByMetro: builder.query({
      query: ({ metro, hub, fromDate, toDate }) => {
        const params = {};
        if (metro) params.metro = metro;
        if (hub) params.hub = hub;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        return {
          url: "shift-schedules",
          params,
        };
      },
      providesTags: ["ShiftDailySchedule"],
    }),
    // No invalidatesTags here on purpose: "Save Week" fires one upsert per day
    // in parallel. With RTK Query 1.x, the first upsert to finish would start a
    // refetch, and every later invalidation (and the caller's own refetch) is
    // dropped while that refetch is still pending. The cache then holds a
    // snapshot from mid-save, which resets the grid to stale data. The caller
    // refetches once after the whole batch has finished instead.
    upsertSchedule: builder.mutation({
      query: (body) => ({
        url: "shift-schedules",
        method: "POST",
        body,
      }),
    }),
    runShiftsFromSchedule: builder.mutation({
      query: (body) => ({
        url: "shift-schedules/run",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && ["ShiftDailySchedule", "Order"],
    }),
  }),
});

export const {
  useGetSchedulesByMetroQuery,
  useUpsertScheduleMutation,
  useRunShiftsFromScheduleMutation,
} = shiftDailyScheduleApi;
